var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 3.485a1.13 1.13 0 011.607 0 1.15 1.15 0 010 1.62l-6.363 6.41a1.13 1.13 0 01-1.608 0L.333 5.105a1.15 1.15 0 010-1.62 1.13 1.13 0 011.607 0L7.5 9.086l5.56-5.6z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonArrowDown;